/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';

import { getBrandName } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import findContent from '../../../../gql/queries/findContent';

const useCgcMessage = ({
    productBrand = null,
    title = 'CGC PDP',
} = {}) => {
    const brand = useSelector(getBrandName);

    const QUERY = findContent({
        brand: productBrand || brand,
        locale: 'en-us',
        contentType: 'gci_messaging',
        query: `\\"title\\" : \\"${title}\\"`,
    });

    return useQuery(QUERY);
};

export default useCgcMessage;
